<script setup lang="ts">
import TLogin from './TLogin.vue';
import TPinLogin from './TPinLogin.vue';
import TLoginFailedModal from './TLoginFailedModal.vue';
</script>

<template>
  <TLogin />
  <TPinLogin />
  <TLoginFailedModal />
</template>
